import Chip from '$tablet-app/src/app/components/Chip';
import { ChipProps } from '$tablet-app/src/app/components/Chip/Chip';
import { palette } from '$tablet-app/src/app/theme';
import { MealType } from '@akin-home/amplify';
import React, { FC } from 'react';
import { getColorForMealType } from '../models';

interface Props extends ChipProps {
  mealType: MealType;
}

const MealTypeChip: FC<Props> = ({ mealType, ...props }) => (
  <Chip
    textColor={palette.white}
    color={getColorForMealType(mealType)}
    {...props}
  >
    {mealType}
  </Chip>
);

export default MealTypeChip;
